export const isFormControlFocused = (event: KeyboardEvent): boolean => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  return target.matches(
    'input, textarea, select, [role="textbox"], [role="combobox"], [role="searchbox"]',
  );
};
